import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' },
     loadChildren: () => import('./lancamento-folha-listar/lancamento-folha-listar.module')
     .then(m => m.LancamentoFolhaListarModule) },
  ])],
  exports: [RouterModule]
})
export class LancamentoFolhaRoutingModule { }
